import type { Dictionary } from "./en";

export const es: Partial<Dictionary> = {
  "lang.select": "Idioma",
  "lang.change": "Cambiar idioma",

  "nav.hot": "Hot",
  "nav.categories": "Categorías",
  "nav.marketplace": "Marketplace",
  "nav.fund": "Financiar",
  "nav.promote": "Promocionar",
  "nav.earn": "Ganar",
  "nav.referrals": "Referidos",
  "nav.soon": "Pronto",
  "nav.login": "Entrar",
  "nav.dashboard": "Panel",
  "nav.getHot": "Ponte Hot",
  "nav.menu": "Menú",
  "nav.walletBalance": "Saldo de Heat",
  "nav.home": "Inicio de BeHot.Now",
  "nav.profile": "Panel",
  "nav.messages": "Mensajes",
  "nav.logout": "Cerrar sesión",
  "nav.balance": "Saldo",

  "footer.tagline": "Un solo lugar para descubrir, contratar, vender y promocionar. Entra en la tabla. Sé HOT. Que te vean.",
  "footer.howItWorks": "Cómo funciona",
  "footer.operatedBy": "Operado por",
  "footer.disclosure":
    "Las posiciones pagadas están claramente marcadas como pagadas. Precios mostrados en USD.",
  "footer.platform": "Plataforma",
  "footer.comingSoon": "Próximamente",
  "footer.legal": "Legal",
  "footer.hotNow": "Hot ahora",
  "footer.hotHistory": "Historial HOT",
  "footer.getHot": "Ponte Hot",
  "footer.referrals": "Referidos",
  "footer.withdrawal": "Derecho de desistimiento",
  "footer.terms": "Términos del servicio",
  "footer.privacy": "Política de privacidad",
  "footer.cookie": "Política de cookies",
  "footer.rights": "Todos los derechos reservados.",
  "footer.compareLeaderboards": "Comparar con otros leaderboards",

  "home.h1.q": "¿Qué es",
  "home.h1.a1": "¡Es donde",
  "home.h1.anything": "cualquier cosa",
  "home.h1.a2": "puede competir por la atención!",
  "home.sub1": "¿Eres influencer, figura pública o celebridad?",
  "home.sub2":
    "¿O tienes una canción, un concierto, un perfil, una marca, una startup, una app, un producto, un negocio, un evento o incluso solo una idea?",
  "home.getItOnCharts": "Ponlo en las listas",
  "home.now": "ya",
  "home.moreBoosts": "Más boosts.",
  "home.higherRanking": "Mejor posición.",
  "home.morePeople": "Más gente te ve.",
  "home.more": "Más",
  "home.browseChart": "Ver la lista de {label}",
  "home.listIt": "PUBLÍCALO",
  "home.boostIt": "IMPÚLSALO",
  "home.climb": "SUBE",
  "home.getSeen": "QUE TE VEAN",
  "home.howItWorks": "Cómo funciona",
  "home.generalBoard": "TABLA GENERAL",
  "home.podium.title": "Top 3 de cada board",
  "home.podium.sub": "El podio actual de cada board de categoría.",
  "home.generalBoardSub":
    "Los mejores listados de todas las categorías, ordenados por Heat activo total.",
  "home.allBoards": "Todas las tablas",
  "home.loadingBoard": "Cargando la tabla general…",

  "lowHeat.title": "Te estás quedando sin Heat",
  "lowHeat.body":
    "Te estás quedando sin Heat: invita a tus amigos y gana más Heat, o recarga tu cartera ahora.",
  "lowHeat.invite": "Invitar amigos",
  "lowHeat.topUp": "Recargar cartera",
  "lowHeat.later": "Más tarde",

  "cookie.title": "Usamos cookies",
  "cookie.accept": "Aceptar todo",
  "cookie.reject": "Rechazar las no esenciales",
  "cookie.settings": "Configuración de cookies",
  "cookie.save": "Guardar preferencias",

  "common.close": "Cerrar",
  "common.loading": "Cargando…",
  "hiw.h1": "Cómo funciona BeHot.Now",
  "hiw.toc": "En esta página",
  "hiw.toc.title": "Índice",
  "hiw.toc.steps": "Los cinco pasos",
  "hiw.toc.rules": "Reglas de clasificación",
  "hiw.toc.entry": "Cómo funciona el precio de entrada",
  "hiw.toc.glossary": "Glosario",
  "hiw.toc.pricing": "Precios",
  "hiw.toc.faq": "Preguntas frecuentes",
  "hiw.toc.roadmap": "Qué llega pronto",
  "hiw.toc.services": "Todos los servicios",
  "hiw.toc.contact": "Contacto",
  "hiw.steps.title": "Los cinco pasos",
  "hiw.ready.title": "¿Listo para competir?",
  "hiw.ready.body": "Publica tu proyecto o descubre qué está en tendencia ahora mismo.",
  "hiw.ready.list": "Publícate ya",
  "hiw.ready.browse": "Ver las listas",
  "hiw.rules.title": "Reglas de clasificación",
  "hiw.entry.title": "Cómo se calcula el precio de entrada a una tabla",
  "hiw.entry.intro": "Entrar en una tabla es simple, pero el precio es dinámico. Siempre pagas el Heat activo más bajo de la tabla más el incremento de esa tabla. Este ejemplo lo muestra con claridad.",
  "hiw.entry.lowest": "Heat activo más bajo actual en la tabla",
  "hiw.entry.plus": "+ incremento",
  "hiw.entry.increment": "Incremento de la tabla",
  "hiw.entry.min": "Tu coste mínimo de entrada",
  "hiw.entry.note": "Si la tabla está vacía o se acaba de reiniciar, el coste de entrada es la oferta de apertura —normalmente 3 Heat—, así que los primeros entran barato antes de que la carrera se caliente.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "Glosario",
  "hiw.pricing.title": "Precios",
  "hiw.pricing.oneHeat": "Precio de 1 Heat",
  "hiw.pricing.oneHeatNote": "Pago único · sin suscripción",
  "hiw.pricing.listing": "Precio de publicación",
  "hiw.pricing.listingNote": "Para publicar tu proyecto en una tabla",
  "hiw.pricing.entry": "Entrada a la tabla",
  "hiw.pricing.entryValue": "Heat más bajo + incremento",
  "hiw.pricing.entryNote": "Ejemplo: 12 Heat + 1 = 13 Heat para entrar",
  "hiw.pricing.opening": "Oferta de apertura",
  "hiw.pricing.openingNote": "Coste de entrada en una tabla nueva o vacía",
  "hiw.faq.title": "Preguntas frecuentes",
  "hiw.roadmap.title": "Qué llega pronto",
  "hiw.soon": "Próximamente",
  "hiw.promote.body": "Compra acciones promocionales reales de creadores: posts, stories, menciones y colaboraciones, a precios fijos con depósito en garantía y prueba de entrega.",
  "hiw.promote.more": "Saber más sobre Promote",
  "hiw.earn.body": "Los creadores publican su tarifa, reciben encargos directos, entregan con prueba y retiran sus ganancias en USD.",
  "hiw.earn.more": "Saber más sobre Earn",
  "hiw.services.title": "Todos los servicios, explicados",
  "hiw.services.intro": "BeHot.Now es mucho más que la tabla. Esto es todo lo que hace la plataforma hoy y todo lo que está en camino.",
  "hiw.services.open": "Abrir {name}",
  "hiw.contact.title": "Habla con nosotros",
  "hiw.contact.intro": "Elige el servicio sobre el que consultas —incluidos Soporte y Ventas— y lo enviaremos al equipo adecuado.",
  "hiw.cta.title": "¿Listo para la posición 01?",
  "hiw.cta.button": "Entrar en una tabla",
  "stats.liveUsers": "{n} usuarios en vivo",
  "stats.totalVisits": "{n} visitas totales",
};
